
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#FFAA80","d":"M2.898 15.344h1.196v2.11c0 .852.694 1.546 1.547 1.546h8.718c.853 0 1.547-.694 1.547-1.547v-2.11h1.196A1.9 1.9 0 0019 13.446v-6.61a1.9 1.9 0 00-1.898-1.897h-1.196V2.546c0-.853-.694-1.547-1.547-1.547H5.641c-.853 0-1.547.694-1.547 1.547v2.39H2.898A1.9 1.9 0 001 6.837v6.61a1.9 1.9 0 001.898 1.898zm11.32 1.969H5.782v-5.625h8.438v5.624zM5.782 2.688h8.438v2.25H5.78v-2.25zM2.688 6.835c0-.116.094-.211.21-.211h14.204c.116 0 .21.095.21.21v6.61c0 .117-.094.211-.21.211h-1.196v-2.812a.844.844 0 00-.844-.844H4.938a.844.844 0 00-.844.844v2.812H2.898a.211.211 0 01-.21-.21v-6.61z"}}),_c('path',{attrs:{"fill":"#FFAA80","d":"M4.376 9.156a.844.844 0 100-1.687.844.844 0 100 1.687z"}})])
          )
        }
      }
    